import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Montserrat: Country = {
    identifier: "Montserrat",
    name: "Montserrat",
    countryCode: "MS",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: false,
    flag: "🇲🇸",
    svgPath: "m 300.47675,415.5674 -0.016,0.172 -0.19,-0.053 -0.004,-0.152 0.089,-0.154 0.044,-0.015 z",
}
